export const MORPHIS_TARGET_ID = 'morphis-wrapper';
export const MORPHIS_TARGET_SELECTOR = `#${MORPHIS_TARGET_ID}`;
export const MORPHIS_JQUERY_SELECTOR = `$("${MORPHIS_TARGET_SELECTOR}")`;
